import React, { useState } from 'react';
import TicketStatusBadge from './TicketStatusBadge';

const TicketDetailPanel = ({ ticket = {}, onClose = () => {}, responsables = [] }) => {
  // Usar la prop 'responsables' directamente para el selector
  // Si ticket.responsable es un objeto, usar su id; si es string, usar directamente
  const initialResponsable = typeof ticket.responsable === 'object' && ticket.responsable !== null ? ticket.responsable.id : (ticket.responsable || '');
  const [selectedResponsable, setSelectedResponsable] = useState(initialResponsable);
  if (!ticket.id) {
    return (
      <div className="fixed inset-0 bg-gray-900 bg-opacity-50 flex items-center justify-center p-4 z-50">
        <div className="bg-white p-8 rounded-2xl shadow-2xl w-full max-w-md text-center">
          <p className="text-gray-600">Selecciona un ticket para ver los detalles.</p>
          <button
            onClick={onClose}
            className="mt-6 px-6 py-2 bg-gray-800 text-white rounded-lg hover:bg-gray-700 transition-colors"
          >
            Cerrar
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="fixed inset-0 bg-gray-900 bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white p-8 rounded-2xl shadow-2xl w-full max-w-2xl transform transition-all duration-300 scale-100 opacity-100">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-2xl font-bold text-gray-800">Detalles del Ticket #{ticket.id}</h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 transition-colors"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        {/* Selector de responsable */}
        <div className="mb-6">
          <label className="block text-sm font-semibold text-gray-700 mb-1">Cambiar responsable</label>
          <select
            className="px-4 py-2 rounded-lg border border-gray-300 bg-white shadow-sm w-full"
            value={selectedResponsable}
            onChange={e => setSelectedResponsable(e.target.value)}
          >
            <option value="">Seleccione responsable</option>
            {Array.isArray(responsables) && responsables.map((r, idx) => (
              <option key={r.id} value={r.id}>{r.nombre}</option>
            ))}
          </select>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
          <div>
            <p className="text-sm text-gray-500">Asunto</p>
            <p className="text-gray-800 font-medium">{ticket.subject}</p>
          </div>
          <div>
            <p className="text-sm text-gray-500">Solicitante</p>
            <p className="text-gray-800 font-medium">{ticket.requester}</p>
          </div>
          <div>
            <p className="text-sm text-gray-500">Asignado a</p>
            <p className="text-gray-800 font-medium">{ticket.assignedTo}</p>
          </div>
          <div>
            <p className="text-sm text-gray-500">Fecha</p>
            <p className="text-gray-800 font-medium">{ticket.date}</p>
          </div>
          <div className="col-span-2">
            <p className="text-sm text-gray-500">Estado</p>
            <TicketStatusBadge status={ticket.status} />
          </div>
        </div>

        <div>
          <p className="text-sm text-gray-500 mb-2">Descripción</p>
          <div className="bg-gray-50 p-4 rounded-lg border border-gray-200 text-gray-700 text-sm leading-relaxed">
            {ticket.description || 'No hay descripción disponible.'}
          </div>
        </div>

        <div className="mt-8 flex justify-end space-x-3">
          <button className="px-5 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors">
            Editar Ticket
          </button>
          <button className="px-5 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors">
            Eliminar Ticket
          </button>
        </div>
      </div>
    </div>
  );
};

export default TicketDetailPanel;